import Vue from 'vue'
import VueI18n from 'vue-i18n'

import fa from './fa';
import en from './en';
import ar from './ar';

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'fa', // set default locale
  messages: { fa, en, ar },
  
})
